import React from 'react';

const ProgressCard = (props) => {
    const { className, content } = props;
    const themeClass = content.theme ? ` msync-stat--is-theme-${content.theme}` : '';
    const additionalClass = className ? ` ${className}` : '';

    return (
        <div className={`msync-stat${additionalClass}${themeClass}`}>
            <span className='msync-stat__details'>
                {content.value ?? 0} {(typeof content.percentage === 'number' || content.percentage === 0) && `(${content.percentage}%)`}
            </span>
            <span className='msync-stat__term'>
                {content.title?.toLowerCase() ?? ''}
            </span>
        </div>
    );
};

export default ProgressCard;